import regexList from "./utils/regexList";
import regexTest from "./utils/regexTest";

export default function isNepaliDate(str, responseText) {
    const regVal = regexList.nepDate.pattern;
    return regexTest(str, regVal, responseText) || regexList.nepDate.response;
}